/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './speaker.component.html',
  styleUrls: ["./speaker.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class SpeakerComponent  {
  @Input("speaker") speaker?;
  public rest = inject(RestService);
  public translate = inject(TranslateService);

}